import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { EMOTION_TYPE } from 'helper';
import { useSelectChatBottom } from 'modules/hooks';
/**
 * Emotion
 */
const Emotion = ({ boxStyle, item, viewType }) => {
  return (
    <div className="_emotion_div">
      <div className="_message" style={boxStyle}>
            <img src={EMOTION_TYPE(item.value)} alt="" /> 
      </div>
    </div>
  );
};
Emotion.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
Emotion.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default Emotion;
